module.exports = __webpack_public_path__ + "static/img/1_1_1.9c3c5ea0.jpg";